import { useState } from "react";
import "./Contact.css";
import config from "../Config/Config.json";

function Contact() {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    mobile: "",
    subject: "",
    message: "",
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const validate = () => {
    const newErrors = {};
    if (!formData.firstName.trim()) newErrors.firstName = "First name is required";
    if (!formData.lastName.trim()) newErrors.lastName = "Last name is required";
    if (!formData.email.trim()) newErrors.email = "Email is required";
    else if (!/\S+@\S+\.\S+/.test(formData.email)) newErrors.email = "Invalid email";
    if (!formData.mobile.trim()) newErrors.mobile = "Mobile number is required";
    else if (!/^\d{10}$/.test(formData.mobile)) newErrors.mobile = "Mobile must be 10 digits";
    if (!formData.subject.trim()) newErrors.subject = "Subject is required";
    if (!formData.message.trim()) newErrors.message = "Message is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" }); // clear error on change
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validate()) return;

    setLoading(true);
    const first_name = formData.firstName
    const last_name = formData.lastName
    const email = formData.email
    const mobile = formData.mobile
    const subject = formData.subject
    const message = formData.message
    const mailtoLink = `mailto:${config.email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(
      `Name: ${first_name} ${last_name}\nEmail: ${email}\nMobile: ${mobile}\n\nMessage:\n${message}`
    )}`;

    window.location.href = mailtoLink;
  };

  return (
    <div className="contact-div-base">
      <div className="contact-div">
        <div className="contact-div-1">
          <h1>Contact</h1>
          <div className="contact-subtitle">Looking forward to hearing from you</div>
          <br />
          <div className="contact-title">Phone</div>
          <div className="contact-subtitle"><a style={{textDecoration: 'none', color: 'black'}}  href={`tel:${config.mobile}`}>{config.mobile}</a></div>
          <br />
          <div className="contact-title">Email</div>
          <div className="contact-subtitle"><a style={{textDecoration: 'none', color: 'black'}} href={`mailto:${config.email}`}>{config.email}</a></div>
        </div>

        <div className="contact-div-2">
          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="form-row">
              <div className="input-container">
                <input
                  type="text"
                  name="firstName"
                  placeholder="First Name"
                  className="input-half"
                  value={formData.firstName}
                  onChange={handleChange}
                />
                {errors.firstName && <span className="error-text">{errors.firstName}</span>}
              </div>

              <div className="input-container">
                <input
                  type="text"
                  name="lastName"
                  placeholder="Last Name"
                  className="input-half"
                  value={formData.lastName}
                  onChange={handleChange}
                />
                {errors.lastName && <span className="error-text">{errors.lastName}</span>}
              </div>
            </div>

            <div className="form-row">
              <div className="input-container">
                <input
                  type="email"
                  name="email"
                  placeholder="Email"
                  className="input-half"
                  value={formData.email}
                  onChange={handleChange}
                />
                {errors.email && <span className="error-text">{errors.email}</span>}
              </div>

              <div className="input-container">
                <input
                  type="tel"
                  name="mobile"
                  placeholder="Mobile"
                  className="input-half"
                  value={formData.mobile}
                  onChange={handleChange}
                />
                {errors.mobile && <span className="error-text">{errors.mobile}</span>}
              </div>
            </div>

            <div className="input-container">
              <input
                type="text"
                name="subject"
                placeholder="Subject"
                className="input-full"
                value={formData.subject}
                onChange={handleChange}
              />
              {errors.subject && <span className="error-text">{errors.subject}</span>}
            </div>

            <div className="input-container">
              <textarea
                name="message"
                placeholder="Message"
                className="textarea-full"
                value={formData.message}
                onChange={handleChange}
              ></textarea>
              {errors.message && <span className="error-text">{errors.message}</span>}
            </div>

            <button type="submit" className="submit-button" disabled={loading}>
              {loading ? "Sending..." : "Submit"}
            </button>
          </form>
        </div>
      </div>
      <hr className="divider" />
    </div>
  );
}

export default Contact;
